import { Flex, Input, SearchIcon, Text } from '@buffer-mono/popcorn'

import type { Tag } from '~publish/gql/graphql'

import { TagItem } from './TagItem'
import styles from '../Tags.module.css'

interface TagsListProps {
  searchFilter: string
  onSearchChange: (value: string) => void
  filteredTags: Tag[]
  isAdmin: boolean
}

export const TagsList = ({
  searchFilter,
  onSearchChange,
  filteredTags,
  isAdmin,
}: TagsListProps): JSX.Element => (
  <Flex direction="column" gap="sm" className={styles.content}>
    <Input
      prefix={<SearchIcon />}
      size="large"
      placeholder="Search tags..."
      value={searchFilter}
      onChange={(e) => onSearchChange(e.target.value)}
      className={styles.searchInput}
    />

    <Flex direction="column" gap="xs" fullWidth>
      {filteredTags.length === 0 ? (
        <Flex
          justify="center"
          align="center"
          direction="column"
          gap="sm"
          className={styles.noResults}
        >
          <Text size="lg" weight="medium">
            No tags found
          </Text>
          <Text color="subtle">Try adjusting your search terms</Text>
        </Flex>
      ) : (
        filteredTags.map((tag) => (
          <TagItem key={tag.id} tag={tag} isAdmin={isAdmin} />
        ))
      )}
    </Flex>
  </Flex>
)
